export default __webpack_public_path__ + "static/media/Strugani 18.a8c4d5a2.jpg";